import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./iconInteractive.html";
export const BUTTON = 'button';
export const LINK = 'link';
export let Size = /*#__PURE__*/function (Size) {
  Size["Default"] = "default";
  Size["Large"] = "large";
  Size["Small"] = "small";
  Size["XSmall"] = "xsmall";
  return Size;
}({});
export let Theme = /*#__PURE__*/function (Theme) {
  Theme["Default"] = "default";
  Theme["Blue"] = "blue";
  Theme["Red"] = "red";
  Theme["Pink"] = "pink";
  Theme["Indigo"] = "indigo";
  Theme["Teal"] = "teal";
  Theme["Purple"] = "purple";
  Theme["Green"] = "green";
  Theme["HotOrange"] = "hot-orange";
  Theme["Violet"] = "violet";
  Theme["Yellow"] = "yellow";
  return Theme;
}({});
export let TransparentBackground = /*#__PURE__*/function (TransparentBackground) {
  TransparentBackground["Transparent"] = "true";
  TransparentBackground["Default"] = "false";
  return TransparentBackground;
}({});
class IconInteractive extends LightningElement {
  constructor(...args) {
    super(...args);
    this.theme = Theme.Default;
    this.size = Size.Default;
    this.ariaLabel = null;
    this.ariaLive = null;
    this.type = null;
    this.form = null;
    this.disabled = false;
    this.href = null;
    this.name = null;
    this.icon = void 0;
    this.iconDescription = void 0;
    this.transparentBackground = TransparentBackground.Default;
  }
  get analyticsSourceProps() {
    return {
      disabled: this.disabled,
      size: this.size,
      theme: this.theme,
      icon: this.icon,
      iconDescription: this.iconDescription,
      callToAction: {
        label: this.name,
        name: this.name,
        url: this.href
      }
    };
  }
  get elementType() {
    return this.href ? LINK : BUTTON;
  }
  handleAnalytics(event) {
    event.detail[this.elementType] = this.analyticsSourceProps;
  }
  handleClick(event) {
    if (this.disabled) {
      event.stopPropagation();
    }
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(IconInteractive, {
  publicProps: {
    theme: {
      config: 0
    },
    size: {
      config: 0
    },
    ariaLabel: {
      config: 0
    },
    ariaLive: {
      config: 0
    },
    type: {
      config: 0
    },
    form: {
      config: 0
    },
    disabled: {
      config: 0
    },
    href: {
      config: 0
    },
    name: {
      config: 0
    },
    icon: {
      config: 0
    },
    iconDescription: {
      config: 0
    },
    transparentBackground: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(IconInteractive, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;